import React, { useEffect, useState } from 'react'
import '../../cssHelper/helper.css'
import './Video.css'
import Header from '../Header/Header'
import youtubeLogo from '../../assets/youtube-logo.png'
import YouTube from 'react-youtube'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { apiKey, baseUrl } from '../../Constants/Constants'
import Suggession from '../Suggession/Suggession'
import Sidebar from '../Sidebar/Sidebar'
import { setThisSidebar } from '../../redux/redux'


function Video() {

  const dispatch = useDispatch();
  const thisSidebar = useSelector((state) => state.youtube.thisSidebar);
  const [sideConnected, setSideConnected] = useState(false)
  const [related, setRelated] = useState()
  const [comments, setComments] = useState();
  const location = useLocation();
  const getQueryParam = (param) => {
    const queryString = location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(param);
  };
  const videoId = getQueryParam('v');
  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const navigate = useNavigate();
  const setId = (id) => {
    window.location.replace(`/watch?v=${id}`);
  }

  const handleSidbarConnection = () => {
    dispatch(setThisSidebar(true))
    setSideConnected(true)
  }
  
  useEffect(() => {
    fetch(`https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=50&q=Dance&key=${apiKey}`)
    .then(result => result.json())
    .then(data => {
      console.log(data.items);
        setRelated(data.items)
    })
    .catch(err => console.log(err));
  }, [])

  useEffect(() => {
    fetch(`https://youtube.googleapis.com/youtube/v3/commentThreads?part=snippet&videoId=${videoId}&key=${apiKey}`)
    .then(result => result.json())
    .then(data => {
      setComments(data.items)
      console.log(data.items)
    })
    .catch(err => console.log(err));
  }, [])

  return (
    <div className='Video absolute size-full z-100 white-clr'>
      {/* floating side bar */}
      <div className={`floating-slidebar scroll-y scroll-hidden-x absolute left ${thisSidebar ? 'anim-sidebar z-100' : ''} ${!thisSidebar && sideConnected ? 'deanim-sidebar' : ''}`}>
        <Sidebar video={true} />
      </div>
      <div className="video-header flex fixed top w-full">
        <div className="sidebar-header flex gap-05 a-center pl-1 ease-4 p-block-1 span">
          <span onClick={handleSidbarConnection} class="material-symbols-rounded pointer r-50 white-clr youtube-menu-hero">
            menu
          </span>
          <div className="youtube-logo-hero flex gap-05 a-center">
          <img src='https://www.edigitalagency.com.au/wp-content/uploads/Youtube-logo-white-png.png' alt="Youtube" className='youtube-logo cover' />
          <sup className='white-clr'>IN</sup>
          </div>
        </div>
        <Header />
      </div>
      <div className="youtube-videos-body scroll-hidden size-full pt-6">
        <div className="youtube-videos-scroller scroll-y scroll-hidden-x w-full">
          <div className='flex size-full youtube-play-hero'>
            <div className="youtbe-videos-wrapper mob-youtube h-full flex flex-col" >
              {/* video   */}
              <div className="youtube-video-hero pl-6 pr-2 w-full">
                <YouTube videoId={videoId} className='youtube-video-player' opts={opts} style={{ width: '100%', borderRadius: '20px' }} />
              </div>
              {/* vidoe overview  */}
              <div className="video-overview pl-6 pr-2 white-clr flex j-between">
                <div className="left-overview flex flex-col">
                  <p className="font-md bold-600 mt-1">
                    Aasa koode asa veese | Video song
                  </p>
                  <div className="flex gap-05 mt-1 a-center">
                    <img src="" alt="" className="cover img-2 r-50" />
                    <div className="flex flex-col j-center">
                      <span className="font-sm">
                        Random Codez
                      </span>
                      <span className="font-xs flex gap-05 primary">
                        <span>345</span>
                        <span>subscribers</span>
                      </span>
                    </div>
                    <button className="height ml-1 r-vh white-bg black-clr p-inline-1 font-sm bold-500">
                      Subscribe
                    </button>
                  </div>
                </div>
                <div className="right-controls flex a-end gap-1">
                  {/* like or dislike  */}
                  <button className="btn-cntl font-sm height r-vh white-clr flex a-center j-center p-inline-1 gap-1">
                    <span class="material-symbols-rounded">
                      thumb_up
                    </span>
                    <span>32</span>
                    <span className='primary'>|</span>
                    <span class="material-symbols-rounded">
                      thumb_down
                    </span>
                  </button>
                  {/* share   */}
                  <button className="btn-cntl font-sm height r-vh white-clr flex a-center j-center p-inline-1 gap-05">
                    <span class="material-symbols-rounded">
                      share
                    </span>
                    Share
                  </button>
                  <button className="btn-cntl font-sm height r-vh white-clr flex a-center j-center p-inline-1 gap-05">
                    <span class="material-symbols-rounded">
                      download
                    </span>
                    Download
                  </button>
                  <button className="btn-cntl height width r-vh white-clr flex a-center j-center p-inline-1">
                    <span class="material-symbols-rounded">
                      more_horiz
                    </span>
                  </button>
                </div>
              </div>
              <div className='yutb-w pl-6 pr-2'>
                <div className="r-10 vid-descr flex flex-col mt-2 white-clr p-1">
                  <div className='flex gap-05'>
                    <div className="views flex just-g">
                      <span>5</span>
                      <span>views</span>
                      <span>2</span>
                      <span>years</span>
                      <span>ago</span>
                    </div>
                    <p className="primary fonts-m">
                      Yotube DAta API Tutorial
                    </p>
                  </div>
                  <p className="decr-more">
                    Yotube data api ... more
                  </p>
                </div>
              </div>
              {/* comments person  */}
              <div className="comment-wrap yutb-w pl-6 pr-2 flex flex-col mt-1">
                <div className="comment-head flex">
                  <div className='font-md bold-600 flex gap-05'>
                    <span>48</span>
                    <span>Comments</span>
                  </div>
                </div>
                <div className="comment-input-own flex gap-1 mt-1">
                  <img src="https://yt3.ggpht.com/4cJcy56H7KATa58vms162G5g10xp9avyO03yPPbsOadk3tLX7txLZaVWWN-QtIovt5FnURyx=s88-c-k-c0x00ffffff-no-rj" alt="" className="cover r-50 img-1" />
                  <input className='person-input glass height font-sm' type="text" placeholder='Add a comment' />
                </div>
              </div>
              {/* comments public  */}
              <div className="comment-hero">
                <div className="yutb-w comments-public-wrap mt-2 pl-6 pr-2 flex flex-col pb-2">
                {
                    comments && comments.length > 0 ? (
                      comments.map((comment) => (
                        <div className="comment-item p-block-1 flex" key={comment.id}>
                          <div className="flex w-full items-start relative">
                            <div className="flex gap-1">
                              <img 
                                src={comment.snippet.topLevelComment ? comment.snippet.topLevelComment.snippet.authorProfileImageUrl : ''} 
                                alt="none" 
                                className="cover rounded-50 img-1 r-50" 
                              />
                              <div className="comments-view flex flex-col gap-05">
                                <div className="author flex gap-05">
                                  <div className="author-name">
                                    <span>{comment.snippet.topLevelComment ? comment.snippet.topLevelComment.snippet.authorDisplayName : 'Unknown'}</span>
                                  </div>
                                  <div className="primary date-view flex justify-center font-xs">
                                    <span>1</span>
                                    <span>year</span>
                                    <span>ago</span>
                                  </div>
                                </div>
                                {/* comment value */}
                                <p className="comment-value">
                                  {comment.snippet.topLevelComment ? comment.snippet.topLevelComment.snippet.textDisplay : ''}
                                </p>
                                <div className="comment-control flex items-center gap-05">
                                  <span className="material-symbols-rounded">
                                    thumb_up
                                  </span>
                                  <span>32</span>
                                  <span className="material-symbols-rounded">
                                    thumb_down
                                  </span>
                                  <span className="font-xs">
                                    Reply
                                  </span>
                                </div>
                              </div>
                            </div>
                            <span className="material-symbols-rounded pointer absolute right">
                              more_vert
                            </span>
                          </div>
                        </div>
                      ))
                    ) : ''
                  }
                </div>
              </div>
            </div>
            {/* videos related right */}
            <div className="youtube-videos-related flex flex-col pr-6">
              <Suggession />
              <div className="related-videos-wrap flex flex-col gap-1 pb-2">
                {
                  related && related.length > 0 ? (
                    related.map((relate) => (
                      <div  onClick={() => setId(relate.id.videoId)} className="rel-item flex gap-1 relative">
                         <img src={relate.snippet.thumbnails ? relate.snippet.thumbnails.high.url : ''} alt="" className="r-7 cover h-full rel-img" />
                         <div className="rel-detls flex flex-col">
                          <p className='font-sm bold-600'>
                           {relate.snippet.title}
                          </p>
                          <p className="rel-channel primary font-xss mt-05">
                            {relate.snippet.channelTittle}
                          </p>
                          <p className="primary font-xss">
                            <span>3.5</span>
                            <span>M </span>
                            <span>views </span>
                            <span>. </span>
                            <span>5 </span>
                            <span>years </span>
                            <span>ago</span>
                          </p>
                        </div>
                        <span class="material-symbols-rounded poiter absolute right">
                         more_vert
                        </span>
                      </div>
                    ))
                  ): ''
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Video

//youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&myRating=like&key=[YOUR_API_KEY]


// fetch comment parent Id 
  

  // fetch comments 
  